(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Coffe-FAQ"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('coffee-faq')) return;

    class CoffeeFaq extends HTMLElement {
      connectedCallback() {
        var list = this.querySelector('[data-faqs]');
        if (!list) return;
        list.classList.add('is-js');
        var items = Array.from(list.querySelectorAll('[data-faq-item]'));
        var triggers = items.map(function (item) { return item.querySelector('[data-faq-trigger]'); });
        var set = function (item, open) {
          item.classList.toggle('is-open', open);
          item.querySelector('[data-faq-trigger]').setAttribute('aria-expanded', open ? 'true' : 'false');
        };
        items.forEach(function (item, i) {
          triggers[i].addEventListener('click', function () { set(item, !item.classList.contains('is-open')); });
          triggers[i].addEventListener('keydown', function (e) {
            var n = triggers.length, next = null;
            if (e.key === 'ArrowDown') next = triggers[(i + 1) % n];
            if (e.key === 'ArrowUp') next = triggers[(i - 1 + n) % n];
            if (e.key === 'Home') next = triggers[0];
            if (e.key === 'End') next = triggers[n - 1];
            if (next) { e.preventDefault(); next.focus(); }
          });
        });
        this._onSelect = function (e) {
          var item = list.querySelector('[data-block-id="' + (e.detail && e.detail.blockId) + '"]');
          if (item) set(item, true);
        };
        document.addEventListener('shopify:block:select', this._onSelect);
      }

      disconnectedCallback() {
        if (this._onSelect) document.removeEventListener('shopify:block:select', this._onSelect);
      }
    }

    customElements.define('coffee-faq', CoffeeFaq);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Coffe-Hero-Section"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('coffee-hero')) return;

    class CoffeeHero extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.thumbs = Array.from(this.querySelectorAll('[data-thumb]'));
        this.thumbList = this.querySelector('[data-thumbs]');
        this.index = 0;
        var self = this;

        this.thumbs.forEach(function (thumb, i) {
          thumb.addEventListener('click', function () { self.show(i); });
          thumb.addEventListener('keydown', function (e) {
            var n = self.thumbs.length;
            var next = null;
            if (e.key === 'ArrowRight') next = (i + 1) % n;
            if (e.key === 'ArrowLeft') next = (i - 1 + n) % n;
            if (e.key === 'Home') next = 0;
            if (e.key === 'End') next = n - 1;
            if (next !== null) { e.preventDefault(); self.show(next); self.thumbs[next].focus(); }
          });
        });

        this.strip = this.querySelector('.ch__strip');
        if (this.strip) {
          this._onResize = this.markStripRows.bind(this);
          window.addEventListener('resize', this._onResize);
          this.markStripRows();
          if (document.fonts && document.fonts.ready) document.fonts.ready.then(this._onResize);
        }

        var form = this.querySelector('form.ch__form');
        if (form) form.addEventListener('submit', function (e) { self.buy(e, form); });

        this._onBlockSelect = function (e) {
          if (!e.detail || e.detail.sectionId !== self.dataset.sectionId) return;
          var i = self.slides.findIndex(function (s) { return s.dataset.blockId === e.detail.blockId; });
          if (i > -1) self.show(i);
        };
        document.addEventListener('shopify:block:select', this._onBlockSelect);
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:block:select', this._onBlockSelect);
        if (this._onResize) window.removeEventListener('resize', this._onResize);
        this._ready = false;
      }

      /* Hide the divider on any reassurance item that wraps onto a new line. */
      markStripRows() {
        var items = Array.from(this.strip.children);
        items.forEach(function (el) { el.classList.remove('is-row-start'); });
        var lastTop = null;
        items.forEach(function (el, i) {
          var top = el.offsetTop;
          if (i > 0 && lastTop !== null && Math.abs(top - lastTop) > 4) el.classList.add('is-row-start');
          lastTop = top;
        });
      }

      show(i) {
        if (!this.slides[i]) return;
        this.index = i;
        this.slides.forEach(function (s, k) {
          s.classList.toggle('is-active', k === i);
          if (k === i) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true');
        });
        this.thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
        var thumb = this.thumbs[i];
        if (thumb && this.thumbList) {
          var li = thumb.parentElement;
          var left = li.offsetLeft - this.thumbList.offsetLeft - (this.thumbList.clientWidth - li.clientWidth) / 2;
          this.thumbList.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
        }
      }

      /* Add the product to the cart, then go to the cart page or straight to checkout. */
      buy(e, form) {
        e.preventDefault();
        var btn = form.querySelector('[data-cta]');
        var error = form.querySelector('[data-error]');
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        var dest = this.dataset.behavior === 'checkout' ? 'checkout' : 'cart';
        if (error) error.hidden = true;
        if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
        var data = new FormData(form);
        data.delete('return_to');
        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: data
        })
          .then(function (res) {
            return res.json().then(function (body) { return { ok: res.ok, body: body }; });
          })
          .then(function (r) {
            if (!r.ok) throw new Error((r.body && (r.body.description || r.body.message)) || 'Could not add this item.');
            window.location.href = root + dest;
          })
          .catch(function (err) {
            if (error) { error.textContent = err && err.message ? err.message : 'Something went wrong. Please try again.'; error.hidden = false; }
            if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
          });
      }
    }

    customElements.define('coffee-hero', CoffeeHero);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coffe-product-camera"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('product-showcase-pro')) return;

    class ProductShowcasePro extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        this._timers = [];
        this.initGallery();
        this.initVariants();
        this.initVideos();
        this.watchVideos();
        this.initTestimonials();
        this.initShipping();
        this.initFaq();
        this._onBlockSelect = this.onBlockSelect.bind(this);
        document.addEventListener('shopify:block:select', this._onBlockSelect);
      }

      disconnectedCallback() {
        this._timers.forEach(function (t) { clearInterval(t); });
        if (this._videoObserver) this._videoObserver.disconnect();
        document.removeEventListener('shopify:block:select', this._onBlockSelect);
        this._ready = false;
      }

      /* ---------------- Gallery ---------------- */
      initGallery() {
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.thumbs = Array.from(this.querySelectorAll('[data-thumb]'));
        this.thumbTrack = this.querySelector('[data-thumbs]');
        this.index = 0;
        var self = this;

        this.querySelectorAll('[data-gallery-prev]').forEach(function (btn) {
          btn.addEventListener('click', function () { self.goTo(self.index - 1); });
        });
        this.querySelectorAll('[data-gallery-next]').forEach(function (btn) {
          btn.addEventListener('click', function () { self.goTo(self.index + 1); });
        });
        this.thumbs.forEach(function (thumb, i) {
          thumb.addEventListener('click', function () { self.goTo(i); });
        });

        var main = this.querySelector('[data-gallery-main]');
        if (main && this.slides.length > 1) {
          var startX = 0, startY = 0;
          main.addEventListener('touchstart', function (e) {
            startX = e.touches[0].clientX; startY = e.touches[0].clientY;
          }, { passive: true });
          main.addEventListener('touchend', function (e) {
            var dx = e.changedTouches[0].clientX - startX;
            var dy = e.changedTouches[0].clientY - startY;
            if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) self.goTo(self.index + (dx < 0 ? 1 : -1));
          }, { passive: true });
          main.addEventListener('keydown', function (e) {
            if (e.key === 'ArrowLeft') self.goTo(self.index - 1);
            if (e.key === 'ArrowRight') self.goTo(self.index + 1);
          });
        }
      }

      goTo(i) {
        var n = this.slides.length;
        if (!n) return;
        i = ((i % n) + n) % n;
        this.index = i;
        this.slides.forEach(function (s, k) {
          s.classList.toggle('is-active', k === i);
          if (k === i) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true');
        });
        this.thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
        var thumb = this.thumbs[i];
        if (thumb && this.thumbTrack) {
          var left = thumb.offsetLeft - (this.thumbTrack.clientWidth - thumb.clientWidth) / 2;
          this.thumbTrack.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
        }
      }

      /* ---------------- Variants / price / ATC ---------------- */
      initVariants() {
        var json = this.querySelector('[data-variants-json]');
        if (!json) return;
        try { this.variants = JSON.parse(json.textContent); } catch (e) { this.variants = []; }
        this.idInput = this.querySelector('[data-variant-input]');
        this.optionSelects = Array.from(this.querySelectorAll('[data-option-index]'));
        var self = this;
        this.optionSelects.forEach(function (select) {
          select.addEventListener('change', function () { self.onOptionChange(); });
        });
        var form = this.querySelector('form.psp__form');
        if (form) form.addEventListener('submit', function (e) { self.buyNow(e, form); });
      }

      /* Buy now: add the selected variant to the cart, then go straight to checkout. */
      buyNow(e, form) {
        e.preventDefault();
        var btn = form.querySelector('[data-add-button]');
        var error = form.querySelector('[data-buy-error]');
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        var showError = function (msg) {
          if (error) { error.textContent = msg; error.hidden = false; }
          if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
        };
        if (error) error.hidden = true;
        if (this.idInput && !this.idInput.value) {
          showError('This combination is not available. Please choose different options.');
          return;
        }
        if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
        var data = new FormData(form);
        data.delete('return_to');
        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: data
        })
          .then(function (res) {
            return res.json().then(function (body) { return { ok: res.ok, body: body }; });
          })
          .then(function (r) {
            if (!r.ok) throw new Error((r.body && (r.body.description || r.body.message)) || 'Could not add this item.');
            window.location.href = root + 'checkout';
          })
          .catch(function (err) {
            showError(err && err.message ? err.message : 'Something went wrong. Please try again.');
          });
      }

      onOptionChange() {
        var values = this.optionSelects
          .slice()
          .sort(function (a, b) { return a.dataset.optionIndex - b.dataset.optionIndex; })
          .map(function (s) { return s.value; });
        var match = (this.variants || []).find(function (v) {
          return (v.options || []).every(function (o, i) { return o === values[i]; });
        });
        this.updateVariant(match || null);
      }

      updateVariant(v) {
        var scarcity = this.querySelector('[data-scarcity]');
        var error = this.querySelector('[data-buy-error]');
        if (error) error.hidden = true;

        if (!v) {
          if (this.idInput) this.idInput.value = '';
          return;
        }

        if (this.idInput) this.idInput.value = v.id;

        var price = this.querySelector('[data-price-current]');
        if (price) price.innerHTML = v.price;
        var compare = this.querySelector('[data-price-compare]');
        if (compare) {
          if (v.compare) { compare.innerHTML = v.compare; compare.hidden = false; }
          else { compare.innerHTML = ''; compare.hidden = true; }
        }

        if (scarcity) {
          var show = this.dataset.scarcityMode === 'always' ||
            (v.tracked && v.qty <= parseInt(this.dataset.scarcityThreshold, 10));
          scarcity.hidden = !show;
        }

        if (v.image) {
          var slideIndex = this.slides.findIndex(function (s) { return s.dataset.imageId === String(v.image); });
          if (slideIndex > -1) this.goTo(slideIndex);
        }

        if (this.dataset.updateUrl === 'true' && window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      /* ---------------- Video reviews ---------------- */
      initVideos() {
        var self = this;
        this.querySelectorAll('[data-video-play]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var card = btn.closest('[data-video-card]');
            var tpl = card && card.querySelector('[data-video-template]');
            var holder = card && card.querySelector('[data-video-holder]');
            if (!tpl || !holder) return;
            self.querySelectorAll('[data-video-card].is-playing').forEach(function (c) {
              if (c !== card) self.resetVideo(c);
            });
            holder.innerHTML = '';
            holder.appendChild(tpl.content.cloneNode(true));
            card.classList.add('is-playing');
            var video = holder.querySelector('video');
            if (video) {
              video.setAttribute('playsinline', '');
              var p = video.play();
              if (p && p.catch) p.catch(function () {});
              video.focus();
            }
          });
        });
      }

      watchVideos() {
        if (!('IntersectionObserver' in window)) return;
        var self = this;
        this._videoObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting && entry.target.classList.contains('is-playing')) {
              var video = entry.target.querySelector('video');
              if (video) video.pause();
              else self.resetVideo(entry.target);
            }
          });
        }, { threshold: 0.25 });
        this.querySelectorAll('[data-video-card]').forEach(function (card) { self._videoObserver.observe(card); });
      }

      resetVideo(card) {
        var holder = card.querySelector('[data-video-holder]');
        if (holder) holder.innerHTML = '';
        card.classList.remove('is-playing');
      }

      /* ---------------- Testimonials ---------------- */
      initTestimonials() {
        var track = this.querySelector('[data-testi-track]');
        if (!track) return;
        this.testiTrack = track;
        var self = this;
        var prev = this.querySelector('[data-testi-prev]');
        var next = this.querySelector('[data-testi-next]');
        if (prev) prev.addEventListener('click', function () { self.stepTestimonial(-1); });
        if (next) next.addEventListener('click', function () { self.stepTestimonial(1); });

        var seconds = parseInt(this.dataset.testimonialAutoplay, 10) || 0;
        var count = track.querySelectorAll('[data-testi-card]').length;
        if (seconds > 0 && count > 1 && !window.Shopify?.designMode) {
          var paused = false;
          var wrap = this.querySelector('[data-testimonials]');
          wrap.addEventListener('mouseenter', function () { paused = true; });
          wrap.addEventListener('mouseleave', function () { paused = false; });
          wrap.addEventListener('focusin', function () { paused = true; });
          wrap.addEventListener('focusout', function () { paused = false; });
          this._timers.push(setInterval(function () { if (!paused) self.stepTestimonial(1); }, seconds * 1000));
        }
      }

      stepTestimonial(dir) {
        var track = this.testiTrack;
        if (!track) return;
        var w = track.clientWidth;
        var max = track.scrollWidth - w;
        var target = track.scrollLeft + dir * w;
        if (target > max + 5) target = 0;
        else if (target < -5) target = max;
        track.scrollTo({ left: target, behavior: 'smooth' });
      }

      /* ---------------- Shipping countdown & dates ---------------- */
      initShipping() {
        var ship = this.querySelector('[data-shipping]');
        if (!ship) return;
        var d = ship.dataset;
        var cutoff = parseInt(d.cutoffHour, 10) || 0;
        var timer = ship.querySelector('[data-countdown]');
        var business = d.businessDays === 'true';
        var pad = function (n) { return String(n).padStart(2, '0'); };

        var locale = document.documentElement.lang || undefined;
        var fmt;
        try { fmt = new Intl.DateTimeFormat(locale, { month: 'long', day: 'numeric' }); }
        catch (e) { fmt = new Intl.DateTimeFormat(undefined, { month: 'long', day: 'numeric' }); }

        var addDays = function (date, days) {
          var r = new Date(date);
          if (!business) { r.setDate(r.getDate() + days); return r; }
          var added = 0;
          while (added < days) {
            r.setDate(r.getDate() + 1);
            var wd = r.getDay();
            if (wd !== 0 && wd !== 6) added++;
          }
          return r;
        };
        var range = function (base, a, b) {
          var lo = Math.min(a, b), hi = Math.max(a, b);
          var s = fmt.format(addDays(base, lo));
          var e = fmt.format(addDays(base, hi));
          return s === e ? s : s + ' – ' + e;
        };

        var render = function () {
          var now = new Date();
          var cut = new Date(now);
          cut.setHours(cutoff, 0, 0, 0);
          var afterCutoff = now >= cut;
          if (afterCutoff) cut.setDate(cut.getDate() + 1);

          if (timer) {
            var diff = Math.max(0, cut - now);
            var h = Math.floor(diff / 3600000);
            var m = Math.floor((diff % 3600000) / 60000);
            timer.textContent = pad(h) + ' ' + d.hoursLabel + ' ' + pad(m) + ' ' + d.minutesLabel;
          }

          if (d.dateMode === 'auto') {
            var base = new Date(now);
            base.setHours(12, 0, 0, 0);
            if (afterCutoff) base.setDate(base.getDate() + 1);
            var shipped = ship.querySelector('[data-ship-date="shipped"]');
            var delivered = ship.querySelector('[data-ship-date="delivered"]');
            if (shipped) shipped.textContent = range(base, +d.shipMin, +d.shipMax);
            if (delivered) delivered.textContent = range(base, +d.deliverMin, +d.deliverMax);
          }
        };

        render();
        this._timers.push(setInterval(render, 30000));
      }

      /* ---------------- FAQ accordions ---------------- */
      initFaq() {
        var wrap = this.querySelector('[data-faq]');
        if (!wrap) return;
        wrap.classList.add('is-js');
        this.faqItems = Array.from(wrap.querySelectorAll('[data-faq-item]'));
        this.faqSingle = this.dataset.faqSingle === 'true';
        var self = this;
        var triggers = this.faqItems.map(function (item) { return item.querySelector('[data-faq-trigger]'); });
        this.faqItems.forEach(function (item, i) {
          var trigger = triggers[i];
          trigger.addEventListener('click', function () { self.toggleFaq(item); });
          trigger.addEventListener('keydown', function (e) {
            var next = null;
            if (e.key === 'ArrowDown') next = triggers[(i + 1) % triggers.length];
            if (e.key === 'ArrowUp') next = triggers[(i - 1 + triggers.length) % triggers.length];
            if (e.key === 'Home') next = triggers[0];
            if (e.key === 'End') next = triggers[triggers.length - 1];
            if (next) { e.preventDefault(); next.focus(); }
          });
        });
      }

      toggleFaq(item, force) {
        var open = typeof force === 'boolean' ? force : !item.classList.contains('is-open');
        var self = this;
        if (open && this.faqSingle) {
          this.faqItems.forEach(function (other) { if (other !== item) self.setFaq(other, false); });
        }
        this.setFaq(item, open);
      }

      setFaq(item, open) {
        item.classList.toggle('is-open', open);
        var trigger = item.querySelector('[data-faq-trigger]');
        if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      }

      /* ---------------- Theme editor ---------------- */
      onBlockSelect(e) {
        if (!e.detail || e.detail.sectionId !== this.dataset.sectionId) return;
        var id = e.detail.blockId;
        var slideIndex = this.slides.findIndex(function (s) { return s.dataset.blockId === id; });
        if (slideIndex > -1) { this.goTo(slideIndex); return; }
        var faqItem = this.querySelector('[data-faq-item][data-block-id="' + id + '"]');
        if (faqItem) { this.toggleFaq(faqItem, true); return; }
        if (this.testiTrack) {
          var card = this.testiTrack.querySelector('[data-block-id="' + id + '"]');
          if (card) this.testiTrack.scrollTo({ left: card.offsetLeft - this.testiTrack.offsetLeft, behavior: 'smooth' });
        }
      }
    }

    customElements.define('product-showcase-pro', ProductShowcasePro);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["doctors-testimonial"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('expert-carousel')) return;

    class ExpertCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        if (!this.track) return;
        this.loop = this.dataset.loop === 'true';

        this._update = this.update.bind(this);
        this._onBlockSelect = this.onBlockSelect.bind(this);
        this.track.addEventListener('scroll', this._update, { passive: true });
        window.addEventListener('resize', this._update);
        document.addEventListener('shopify:block:select', this._onBlockSelect);
        if (this.prev) this.prev.addEventListener('click', () => this.go(-1));
        if (this.next) this.next.addEventListener('click', () => this.go(1));
        this.track.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(-1); }
          if (e.key === 'ArrowRight') { e.preventDefault(); this.go(1); }
        });

        this.setupAutoplay();
        this.update();
      }

      disconnectedCallback() {
        if (this.track) this.track.removeEventListener('scroll', this._update);
        window.removeEventListener('resize', this._update);
        document.removeEventListener('shopify:block:select', this._onBlockSelect);
        clearInterval(this._timer);
      }

      stepSize() {
        const card = this.track.firstElementChild;
        if (!card) return this.track.clientWidth;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        return card.getBoundingClientRect().width + gap;
      }

      maxScroll() {
        return this.track.scrollWidth - this.track.clientWidth;
      }

      go(dir) {
        const max = this.maxScroll();
        const left = this.track.scrollLeft;
        if (this.loop && dir > 0 && left >= max - 2) return this.track.scrollTo({ left: 0 });
        if (this.loop && dir < 0 && left <= 2) return this.track.scrollTo({ left: max });
        this.track.scrollBy({ left: dir * this.stepSize() });
      }

      update() {
        const max = this.maxScroll();
        const left = this.track.scrollLeft;
        const atStart = left <= 2;
        const atEnd = left >= max - 2;
        this.classList.toggle('is-static', max <= 2);
        this.classList.toggle('is-end', atEnd);
        if (this.prev) this.prev.disabled = !this.loop && atStart;
        if (this.next) this.next.disabled = !this.loop && atEnd;
      }

      setupAutoplay() {
        const seconds = parseInt(this.dataset.autoplay, 10) || 0;
        if (!seconds || (window.Shopify && window.Shopify.designMode)) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        let paused = false;
        const pause = () => { paused = true; };
        const resume = () => { paused = false; };
        this.addEventListener('mouseenter', pause);
        this.addEventListener('mouseleave', resume);
        this.addEventListener('focusin', pause);
        this.addEventListener('focusout', resume);
        this.addEventListener('touchstart', pause, { passive: true });
        this._timer = setInterval(() => {
          if (paused || document.hidden) return;
          if (!this.loop && this.track.scrollLeft >= this.maxScroll() - 2) this.track.scrollTo({ left: 0 });
          else this.go(1);
        }, seconds * 1000);
      }

      onBlockSelect(e) {
        if (!e.detail || e.detail.sectionId !== this.dataset.sectionId) return;
        const card = this.track.querySelector('[data-block-id="' + e.detail.blockId + '"]');
        if (card) this.track.scrollTo({ left: card.offsetLeft - this.track.offsetLeft });
      }
    }

    customElements.define('expert-carousel', ExpertCarousel);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-showcase"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('product-showcase-section')) return;

    class ProductShowcaseSection extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        this._timers = [];
        this.initGallery();
        this.initVariants();
        this.initVideos();
        this.initTestimonials();
        this.initShipping();
        this._onBlockSelect = this.onBlockSelect.bind(this);
        document.addEventListener('shopify:block:select', this._onBlockSelect);
      }

      disconnectedCallback() {
        this._timers.forEach(function (t) { clearInterval(t); });
        document.removeEventListener('shopify:block:select', this._onBlockSelect);
        this._ready = false;
      }

      /* ---------------- Gallery ---------------- */
      initGallery() {
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.thumbs = Array.from(this.querySelectorAll('[data-thumb]'));
        this.thumbTrack = this.querySelector('[data-thumbs]');
        this.index = 0;
        var self = this;

        this.querySelectorAll('[data-gallery-prev]').forEach(function (btn) {
          btn.addEventListener('click', function () { self.goTo(self.index - 1); });
        });
        this.querySelectorAll('[data-gallery-next]').forEach(function (btn) {
          btn.addEventListener('click', function () { self.goTo(self.index + 1); });
        });
        this.thumbs.forEach(function (thumb, i) {
          thumb.addEventListener('click', function () { self.goTo(i); });
        });

        var main = this.querySelector('[data-gallery-main]');
        if (main && this.slides.length > 1) {
          var startX = 0, startY = 0;
          main.addEventListener('touchstart', function (e) {
            startX = e.touches[0].clientX; startY = e.touches[0].clientY;
          }, { passive: true });
          main.addEventListener('touchend', function (e) {
            var dx = e.changedTouches[0].clientX - startX;
            var dy = e.changedTouches[0].clientY - startY;
            if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) self.goTo(self.index + (dx < 0 ? 1 : -1));
          }, { passive: true });
          main.addEventListener('keydown', function (e) {
            if (e.key === 'ArrowLeft') self.goTo(self.index - 1);
            if (e.key === 'ArrowRight') self.goTo(self.index + 1);
          });
        }
      }

      goTo(i) {
        var n = this.slides.length;
        if (!n) return;
        i = ((i % n) + n) % n;
        this.index = i;
        this.slides.forEach(function (s, k) {
          s.classList.toggle('is-active', k === i);
          if (k === i) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true');
        });
        this.thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
        var thumb = this.thumbs[i];
        if (thumb && this.thumbTrack) {
          var left = thumb.offsetLeft - (this.thumbTrack.clientWidth - thumb.clientWidth) / 2;
          this.thumbTrack.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
        }
      }

      /* ---------------- Variants / price / ATC ---------------- */
      initVariants() {
        var json = this.querySelector('[data-variants-json]');
        if (!json) return;
        try { this.variants = JSON.parse(json.textContent); } catch (e) { this.variants = []; }
        var select = this.querySelector('[data-variant-select]');
        var self = this;
        if (select) select.addEventListener('change', function () { self.updateVariant(select.value); });
      }

      updateVariant(id) {
        var v = (this.variants || []).find(function (x) { return String(x.id) === String(id); });
        if (!v) return;

        var price = this.querySelector('[data-price-current]');
        if (price) price.innerHTML = v.price;
        var compare = this.querySelector('[data-price-compare]');
        if (compare) {
          if (v.compare) { compare.innerHTML = v.compare; compare.hidden = false; }
          else { compare.innerHTML = ''; compare.hidden = true; }
        }

        var btn = this.querySelector('[data-add-button]');
        var label = this.querySelector('[data-add-label]');
        if (btn) btn.disabled = !v.available;
        if (label) label.textContent = v.available ? this.dataset.addLabel : this.dataset.soldOutLabel;

        var scarcity = this.querySelector('[data-scarcity]');
        if (scarcity) {
          var show = false;
          if (v.available) {
            if (this.dataset.scarcityMode === 'always') show = true;
            else show = v.tracked && v.qty > 0 && v.qty <= parseInt(this.dataset.scarcityThreshold, 10);
          }
          scarcity.hidden = !show;
        }

        if (v.image) {
          var slideIndex = this.slides.findIndex(function (s) { return s.dataset.imageId === String(v.image); });
          if (slideIndex > -1) this.goTo(slideIndex);
        }

        if (this.dataset.updateUrl === 'true' && window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      /* ---------------- Video reviews ---------------- */
      initVideos() {
        var self = this;
        this.querySelectorAll('[data-video-play]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var card = btn.closest('[data-video-card]');
            var tpl = card && card.querySelector('[data-video-template]');
            var holder = card && card.querySelector('[data-video-holder]');
            if (!tpl || !holder) return;
            self.querySelectorAll('[data-video-card].is-playing').forEach(function (c) {
              if (c !== card) self.resetVideo(c);
            });
            holder.innerHTML = '';
            holder.appendChild(tpl.content.cloneNode(true));
            card.classList.add('is-playing');
            var video = holder.querySelector('video');
            if (video) {
              video.setAttribute('playsinline', '');
              var p = video.play();
              if (p && p.catch) p.catch(function () {});
              video.focus();
            }
          });
        });
      }

      resetVideo(card) {
        var holder = card.querySelector('[data-video-holder]');
        if (holder) holder.innerHTML = '';
        card.classList.remove('is-playing');
      }

      /* ---------------- Testimonials ---------------- */
      initTestimonials() {
        var track = this.querySelector('[data-testi-track]');
        if (!track) return;
        this.testiTrack = track;
        var self = this;
        var prev = this.querySelector('[data-testi-prev]');
        var next = this.querySelector('[data-testi-next]');
        if (prev) prev.addEventListener('click', function () { self.stepTestimonial(-1); });
        if (next) next.addEventListener('click', function () { self.stepTestimonial(1); });

        var seconds = parseInt(this.dataset.testimonialAutoplay, 10) || 0;
        var count = track.querySelectorAll('[data-testi-card]').length;
        if (seconds > 0 && count > 1 && !window.Shopify?.designMode) {
          var paused = false;
          var wrap = this.querySelector('[data-testimonials]');
          wrap.addEventListener('mouseenter', function () { paused = true; });
          wrap.addEventListener('mouseleave', function () { paused = false; });
          wrap.addEventListener('focusin', function () { paused = true; });
          wrap.addEventListener('focusout', function () { paused = false; });
          this._timers.push(setInterval(function () { if (!paused) self.stepTestimonial(1); }, seconds * 1000));
        }
      }

      stepTestimonial(dir) {
        var track = this.testiTrack;
        if (!track) return;
        var w = track.clientWidth;
        var max = track.scrollWidth - w;
        var target = track.scrollLeft + dir * w;
        if (target > max + 5) target = 0;
        else if (target < -5) target = max;
        track.scrollTo({ left: target, behavior: 'smooth' });
      }

      /* ---------------- Shipping countdown & dates ---------------- */
      initShipping() {
        var ship = this.querySelector('[data-shipping]');
        if (!ship) return;
        var d = ship.dataset;
        var cutoff = parseInt(d.cutoffHour, 10) || 0;
        var timer = ship.querySelector('[data-countdown]');
        var business = d.businessDays === 'true';
        var pad = function (n) { return String(n).padStart(2, '0'); };

        var locale = document.documentElement.lang || undefined;
        var fmt;
        try { fmt = new Intl.DateTimeFormat(locale, { month: 'long', day: 'numeric' }); }
        catch (e) { fmt = new Intl.DateTimeFormat(undefined, { month: 'long', day: 'numeric' }); }

        var addDays = function (date, days) {
          var r = new Date(date);
          if (!business) { r.setDate(r.getDate() + days); return r; }
          var added = 0;
          while (added < days) {
            r.setDate(r.getDate() + 1);
            var wd = r.getDay();
            if (wd !== 0 && wd !== 6) added++;
          }
          return r;
        };
        var range = function (base, a, b) {
          var lo = Math.min(a, b), hi = Math.max(a, b);
          var s = fmt.format(addDays(base, lo));
          var e = fmt.format(addDays(base, hi));
          return s === e ? s : s + ' – ' + e;
        };

        var render = function () {
          var now = new Date();
          var cut = new Date(now);
          cut.setHours(cutoff, 0, 0, 0);
          var afterCutoff = now >= cut;
          if (afterCutoff) cut.setDate(cut.getDate() + 1);

          if (timer) {
            var diff = Math.max(0, cut - now);
            var h = Math.floor(diff / 3600000);
            var m = Math.floor((diff % 3600000) / 60000);
            timer.textContent = pad(h) + ' ' + d.hoursLabel + ' ' + pad(m) + ' ' + d.minutesLabel;
          }

          if (d.dateMode === 'auto') {
            var base = new Date(now);
            base.setHours(12, 0, 0, 0);
            if (afterCutoff) base.setDate(base.getDate() + 1);
            var shipped = ship.querySelector('[data-ship-date="shipped"]');
            var delivered = ship.querySelector('[data-ship-date="delivered"]');
            if (shipped) shipped.textContent = range(base, +d.shipMin, +d.shipMax);
            if (delivered) delivered.textContent = range(base, +d.deliverMin, +d.deliverMax);
          }
        };

        render();
        this._timers.push(setInterval(render, 30000));
      }

      /* ---------------- Theme editor ---------------- */
      onBlockSelect(e) {
        if (!e.detail || e.detail.sectionId !== this.dataset.sectionId) return;
        var id = e.detail.blockId;
        var slideIndex = this.slides.findIndex(function (s) { return s.dataset.blockId === id; });
        if (slideIndex > -1) { this.goTo(slideIndex); return; }
        if (this.testiTrack) {
          var card = this.testiTrack.querySelector('[data-block-id="' + id + '"]');
          if (card) this.testiTrack.scrollTo({ left: card.offsetLeft - this.testiTrack.offsetLeft, behavior: 'smooth' });
        }
      }
    }

    customElements.define('product-showcase-section', ProductShowcaseSection);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sections-review-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('review-carousel')) return;

    class ReviewCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        if (!this.track) return;
        this.loop = this.dataset.loop === 'true';

        this._update = this.update.bind(this);
        this._onBlockSelect = this.onBlockSelect.bind(this);
        this.track.addEventListener('scroll', this._update, { passive: true });
        window.addEventListener('resize', this._update);
        document.addEventListener('shopify:block:select', this._onBlockSelect);
        if (this.prev) this.prev.addEventListener('click', () => this.go(-1));
        if (this.next) this.next.addEventListener('click', () => this.go(1));
        this.track.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(-1); }
          if (e.key === 'ArrowRight') { e.preventDefault(); this.go(1); }
        });

        this.setupAutoplay();
        this.update();
      }

      disconnectedCallback() {
        if (this.track) this.track.removeEventListener('scroll', this._update);
        window.removeEventListener('resize', this._update);
        document.removeEventListener('shopify:block:select', this._onBlockSelect);
        clearInterval(this._timer);
      }

      stepSize() {
        const card = this.track.firstElementChild;
        if (!card) return this.track.clientWidth;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        return card.getBoundingClientRect().width + gap;
      }

      maxScroll() {
        return this.track.scrollWidth - this.track.clientWidth;
      }

      go(dir) {
        const max = this.maxScroll();
        const left = this.track.scrollLeft;
        if (this.loop && dir > 0 && left >= max - 2) return this.track.scrollTo({ left: 0 });
        if (this.loop && dir < 0 && left <= 2) return this.track.scrollTo({ left: max });
        this.track.scrollBy({ left: dir * this.stepSize() });
      }

      update() {
        const max = this.maxScroll();
        const left = this.track.scrollLeft;
        const atStart = left <= 2;
        const atEnd = left >= max - 2;
        this.classList.toggle('is-static', max <= 2);
        this.classList.toggle('is-end', atEnd);
        if (this.prev) this.prev.disabled = !this.loop && atStart;
        if (this.next) this.next.disabled = !this.loop && atEnd;
      }

      setupAutoplay() {
        const seconds = parseInt(this.dataset.autoplay, 10) || 0;
        if (!seconds || (window.Shopify && window.Shopify.designMode)) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        let paused = false;
        const pause = () => { paused = true; };
        const resume = () => { paused = false; };
        this.addEventListener('mouseenter', pause);
        this.addEventListener('mouseleave', resume);
        this.addEventListener('focusin', pause);
        this.addEventListener('focusout', resume);
        this.addEventListener('touchstart', pause, { passive: true });
        this._timer = setInterval(() => {
          if (paused || document.hidden) return;
          if (!this.loop && this.track.scrollLeft >= this.maxScroll() - 2) this.track.scrollTo({ left: 0 });
          else this.go(1);
        }, seconds * 1000);
      }

      onBlockSelect(e) {
        if (!e.detail || e.detail.sectionId !== this.dataset.sectionId) return;
        const card = this.track.querySelector('[data-block-id="' + e.detail.blockId + '"]');
        if (card) this.track.scrollTo({ left: card.offsetLeft - this.track.offsetLeft });
      }
    }

    customElements.define('review-carousel', ReviewCarousel);
  })();

  } catch(e) { console.error(e); }
})();
})();
